import { getArrayDiferences } from '../../helpers';
import {
  FULFILMENT_TYPES,
  ORDER_BY,
  ORDER_TYPES,
  STATUSES_COUNT,
} from './constants';

export const calculateInitialCheckboxGroupState = (statusFromQuery) => {
  const statuses = [
    'requested',
    'processing',
    'ready',
    'done',
    'declined',
    'all',
  ];

  const defaultState = statuses.reduce((state, status) => {
    state[status] = true;
    return state;
  }, {});

  if (!statusFromQuery) {
    return defaultState;
  }

  const statusArrayFromQuery = statusFromQuery.split(',');

  if (statusArrayFromQuery.length === statuses.length - 1) {
    return defaultState;
  }

  const customState = getArrayDiferences(statuses, statusArrayFromQuery).reduce(
    (state, status) => {
      state[status] = false;
      return state;
    },
    { all: false },
  );

  return {
    ...defaultState,
    ...customState,
  };
};

export const transformOrderStatusesToRequestPayload = (orderStatuses) => {
  const { all, ...statuses } = orderStatuses;
  const includedStatuses = Object.keys(statuses).filter(
    (status) => statuses[status],
  );
  if (includedStatuses.length === STATUSES_COUNT) {
    return null;
  }
  return includedStatuses.join(',');
};

export const getRequestPayload = (
  orderStatusesFromState,
  orderStatusesFromQuery,
) => {
  const newOrderStatus = transformOrderStatusesToRequestPayload(
    orderStatusesFromState,
  );

  if (newOrderStatus) {
    return { shouldRunNewQuery: true, payload: newOrderStatus };
  }

  const statusesInQueryCount = orderStatusesFromQuery?.split?.(',')?.length;
  if (!statusesInQueryCount) {
    return { shouldRunNewQuery: false };
  }
  const shouldRunNewQuery = statusesInQueryCount < STATUSES_COUNT;

  return { shouldRunNewQuery };
};

export const getOrderStatus = (order) => {
  const { otc, repeat_id } = order;

  if (!otc) {
    return ORDER_TYPES.RX;
  }

  const hasPmed = otc.find((otcItem) => otcItem.p_med);

  if (!hasPmed && !repeat_id) {
    return ORDER_TYPES.OTC_GSL;
  }

  if (hasPmed && !repeat_id) {
    return ORDER_TYPES.OTC_PMED;
  }

  if (!hasPmed && repeat_id) {
    return ORDER_TYPES.OTC_RX;
  }

  if (hasPmed && repeat_id) {
    return ORDER_TYPES.OTC_RX_PMED;
  }
};

export const getFulfilmentType = (order) => {
  if (!order.delivery) {
    return FULFILMENT_TYPES.COLLECTION;
  }
  if (order.delivery.option === 'postal') {
    return FULFILMENT_TYPES.POSTAL_DELIVERY;
  }
  if (order.payment?.delivery_total) {
    return FULFILMENT_TYPES.PREMIUM_DELIVERY;
  }
  return FULFILMENT_TYPES.FREE_DELIVERY;
};

export const getWorkingHoursFormatted = (hours, days) => {
  if (Number.isInteger(hours)) {
    return `${hours} hours`;
  }
  return `${days} days`;
};

export const isFilteredByRagStatus = (query) => {
  return query.order_by === ORDER_BY.RAG_STATUS;
};

export const isFilteredByPharmacy = (query) => {
  return query.pharmacy_id;
};

export const shouldBeAllOptionChecked = (state) => {
  const { all, ...mainState } = state;
  return Object.values(mainState).every((stateItem) => stateItem);
};
